import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors } from 'utils';
import { Table, Pagination, Tooltip, Input, DatePicker, Select, Modal, Textarea } from 'components';
import { CleanIcon, AddIcon, EditIcon, TrashIcon, CampaignListIcon } from 'assets/icons';
import { InformationService } from 'services';
import moment from 'moment';
import { LightImage } from 'assets/img';
import ModalCreate from '../information/modal-create';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	search: ''
}

class Information extends React.Component<Props> {

	timer: any = undefined;

	state = {
		header: [
			'',
			''
		],
		form: INITIAL_STATE,
		data: [],
		page: 1,
		last_page: 1,
		visible: false,
		item: null
	}

	componentDidMount() {
		this.load();
	}

	load = async (withoutLoading: boolean = false,callback = () => {}) => {
		const res: any = await InformationService.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
			type: Constants.INFORMATION_TYPES.SUGGESTIONS
		});
		this.setState({
			data: res.information.rows,
			last_page: res.information.count
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	add = () => {
		this.setState({
			visible: true
		});
	}

	onClose = () => {
		this.setState({
			visible: false,
			item: null
		},() => this.load(true));
	}

	edit = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible: true,
			item
		});
	}

	delete = async (e: any, item: any) => {
		e.preventDefault();
		Globals.confirm('¿Desea eliminar la información?',async () => {
			await InformationService.delete({
				information_id: item?.id
			});	
			Globals.showSuccess("Se ha eliminado la información correctamente");
			this.load(true);
		});
	}

	render() {
		const { visible } = this.state;

		return (
			<div id="client-information">
		      	<Modal
		          className="modal-create-information"
		          visible={ visible }
		          title={ `${ this.state.item != null ? 'Editar' : 'Creación de' } Información` }
		          onClose={ () => this.onClose() }
		        >
		          <ModalCreate
		          	type={ Constants.INFORMATION_TYPES.SUGGESTIONS }
		          	item={ this.state.item }
		            onClose={ () => this.onClose() } />
		      	</Modal>

				<div className="row row-filter">
					<div className="col-md-9">
						<div className="row">
							<div className="col-md-4">
								<Input
									value={ this.state.form.search }
									name="search"
									placeholder="Buscar"
									searchLeft
									className="input-table"
									onSubmit={ () => this.load() }
									onChange={ (e: any) => {
										clearTimeout(this.timer);
										this.timer = setTimeout(() => {
											this.load(true);
										},1000);
										this.change(e); 
									} } />
							</div>
							<div className="col-md-2">
								{
									this.state.form != INITIAL_STATE && (
										<button className="btn btn-clean" onClick={ () => this.reset() }>
											<img src={ CleanIcon } />
										</button>
									)
								}
							</div>
						</div>
					</div>
					<div className="col-md-3 text-right">
						<button className="btn add-btn" onClick={ this.add }>
							<img src={ AddIcon } />
							<p>Nuevo</p>
						</button>
					</div>
				</div>

				<Table title="Información (IA)" data={ true } header={ this.state.header }>
					<tr>
						<td className="td-title" colSpan={ 2 }>
							<h3>Sugerencias para actuar</h3>
							<p>En este módulo puedes indicar cómo debe actuar o responder el agente en situaciones específicas. Estas sugerencias ayudan a que el agente mantenga el tono, la intención y la forma de atención que deseas para tus clientes. Puedes usarlo para definir comportamientos, redirecciones o respuestas preferidas ante escenarios comunes o ambiguos.</p>
							<div className="container-light">
								<img src={ LightImage } />
								<div style={{ flex: 1 }}>
									<p>Por ejemplo, puedes indicar:</p>
									<ul>
										<li>En caso de que el usuario pregunte fuera del horario laboral. Responde: Nuestro equipo humano no está disponible en este momento, pero puedo tomar tus datos para que te contacten en el próximo horario de atención.</li>
										<li>En caso de que el usuario no proporcione un dato necesario (como nombre o número de pedido), Responde: “Para ayudarte mejor necesito tu número de pedido o el nombre registrado en la compra.”</li>
									</ul>
								</div>
							</div>
						</td>
					</tr>
					{ this.state.data.map((i: any,index: number) => {
						return (
							<tr key={ index }>
								<td style={{ width: '90%' }}>
									<Input
										label="Sugerencia de actuación"
										disabled={ true }
										value={ i.question }
										name="question"
										placeholder="Escribir"
										onChange={ () => {} } />
									<Textarea
										label="Actuación sugerida"
										disabled={ true }
										rows={ 6 }
										value={ i.response }
										placeholder="Escribir"
										name="response"
										onChange={ () => {} } />
								</td>
								<td style={{ 'whiteSpace': 'nowrap' }}>
									<Tooltip title="Editar">
										<a className="link-icon" href="#" onClick={ (e: any) => this.edit(e,i) }>
											<img src={ EditIcon } />
										</a>
									</Tooltip>
									<Tooltip title="Eliminar">
										<a className="link-icon link-red" href="#" onClick={ (e: any) => this.delete(e,i) }>
											<img src={ TrashIcon } />
										</a>
									</Tooltip>
								</td>
							</tr>
						)
					}) }
				</Table>

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					} } />
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Information);